<template>
  <div class="header-p">
    <div class="h-t">科学观测网管理后台</div>
    <div class="h-m">
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
      >
        <div class="avatar-wrapper">
          <img src="@/assets/admin/hp.png" class="user-avatar" />
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="logout">
            <span>退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    async logout() {
      try {
        await this.$store.dispatch("LogOut");
        this.$message.success("已安全退出");
        this.$router.push({ path: "/admin/login" });
      } catch (error) {
        console.error("退出异常:", error);
        this.$router.push({ path: "/admin/login" });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.header-p {
  display: flex;
  .h-t {
    font-size: 20px;
    color: #fff;
  }
  .h-m {
    margin-left: auto;
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 16px;
        }
      }
    }
  }
}
</style>